import type React from 'react'

/** The muted group label above a run of Type panel controls (Font Family, Size, Spacing, …). */
export function SectionHeading({ children }: { children: React.ReactNode }) {
  return (
    <label className="text-xs font-medium text-muted-foreground leading-normal">{children}</label>
  )
}
